import request from '@/utils/request'

const url = 'admin/site.space'
/**
 * 场地信息接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 添加Space
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑Space
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Space
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 删除Space
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
   * 更改Space数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/editStatus`,
      method: 'post',
      data
    })
  },

  /**
   * 根据门店ID获取时间段
   * @returns
   */
  GetTimeSlotsBySite(site_id) {
    return request({
      url: `${url}/getTimeSlotsBySite`,
      method: 'post',
      params: { site_id }
    })
  }

}

export default api
